/**
 * Parses a backend timestamp into a Date, treating timezone-less ISO strings
 * as UTC. The API serializes naive-UTC datetimes ("2026-08-11T23:49:30") with
 * no offset, which `new Date(...)` would misread as LOCAL time — shifting every
 * displayed run time by the viewer's UTC offset. Strings that already carry an
 * offset (staged-file `modified` values end in "+00:00") pass through untouched.
 */
export function parseUtcTimestamp(iso: string): Date {
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/.test(iso)
  return new Date(hasOffset ? iso : `${iso}Z`)
}
